"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dollar = void 0;
var dollarStringRegex = /^\d*\.\d{2}$/;
// Requires amount to have two decimals.
// 0.01 and .01 are valid. 1, 1.0, and 1.000 are invalid.
function dollarStringToCents(amount) {
    if (!dollarStringRegex.test(amount)) {
        return new Error("Invalid dollar string format: ".concat(amount));
    }
    var cents = Number(amount.replace('.', ''));
    if (!Number.isInteger(cents)) {
        return new Error("Converting dollar string ".concat(amount, " to cents did not return an integer. Found ").concat(cents, "."));
    }
    return cents;
}
var Dollar = /** @class */ (function () {
    function Dollar(_cents) {
        this._cents = _cents;
    }
    Dollar.fromString = function (amount) {
        if (typeof amount !== 'string') {
            return new Error("Dollar.fromString called with non-string argument: ".concat(amount, " (type = ").concat(typeof amount, ")"));
        }
        var cents = dollarStringToCents(amount);
        if (cents instanceof Error) {
            return cents;
        }
        return new Dollar(cents);
    };
    Dollar.fromCents = function (cents) {
        if (!Number.isInteger(cents)) {
            return new Error("Trying to create Dollar from invalid cents amount: ".concat(cents, "."));
        }
        return new Dollar(cents);
    };
    Dollar.fromFloat = function (amount) {
        var cents = Math.round(amount * 100);
        return Dollar.fromCents(cents);
    };
    Dollar.zero = function () {
        return new Dollar(0);
    };
    Dollar.prototype.toString = function (currencyPrefix) {
        var amount = (this._cents / 100).toFixed(2);
        if (!currencyPrefix) {
            return amount;
        }
        if (this._cents >= 0) {
            return currencyPrefix + amount;
        }
        return amount[0] + currencyPrefix + amount.slice(1);
    };
    Dollar.prototype.cents = function () {
        return this._cents;
    };
    Dollar.prototype.mult = function (n) {
        var newCents = Math.round(this._cents * n);
        return new Dollar(newCents);
    };
    Dollar.prototype.add = function (d) {
        return new Dollar(this.cents() + d.cents());
    };
    Dollar.prototype.sub = function (d) {
        return new Dollar(this.cents() - d.cents());
    };
    return Dollar;
}());
exports.Dollar = Dollar;
